import script from "./HomeWageSupportDeductionModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./HomeWageSupportDeductionModal.vue?vue&type=script&setup=true&lang=ts"

import "./HomeWageSupportDeductionModal.vue?vue&type=style&index=0&id=6532fca2&lang=scss"

const __exports__ = script;

export default __exports__